import { OptionsObject, ProviderContext, useSnackbar, VariantType } from "notistack";


export const useAlert = () => {
    const alert = useSnackbar();
    return {
        error: (message: string, errorMessage: string) => error(message, alert, errorMessage),
        success: (message: string) => success(message, alert),
        info: (message: string) => info(message, alert),
        warning: (message: string) => warning(message, alert),
    }
}

const baseAlert = (message: string, variant: VariantType, alert: ProviderContext, errorMessage?: string) => {

    let options: OptionsObject = {
        variant: variant,
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        autoHideDuration: 7000,
        preventDuplicate: true,
        "aria-errormessage": errorMessage
    }

    alert.enqueueSnackbar(message, options)
}
const success = (message: string, provider: ProviderContext) => {
    baseAlert(message, "success", provider);
}
const error = (message: string, provider: ProviderContext, errorMessage: string) => {
    baseAlert(message, "error", provider, errorMessage);
}
const info = (message: string, provider: ProviderContext) => {
    baseAlert(message, "info", provider);
}
const warning = (message: string, provider: ProviderContext) => {
    baseAlert(message, "warning", provider);
}

